import { auth } from '../../../firebase';
import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { v4 as uuidv4 } from 'uuid';

const processDealArtifact = (
  orgId,
  dealId,
  interactionId,
  payload,
  callback,
  errCb,
) => {
  return async (dispatch) => {
    dispatch({ type: 'SUBMITTING_DEAL_ARTIFACT_FOR_PROCESSING' });
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const userInfo = localStorage.getItem('userInfo');
        const userId = JSON.parse(userInfo)?.id;
        const reqId = uuidv4();
        try {
          const response = await axios.put(
            `/ads/org/${orgId}/deals/interactions/${interactionId}/post-process`,
            payload,
            {
              params: {
                'request-id': reqId,
                dealId,
              },
              headers: {
                Authorization: `Bearer ${token}`,
              },
            },
          );
          if (response.status === 200) {
            await dispatch({
              type: 'SUBMITTING_DEAL_ARTIFACT_FOR_PROCESSING_DONE',
            });
            if (typeof callback === 'function') {
              callback(response?.data);
            }
          } else {
            dispatch({
              type: 'SUBMITTING_DEAL_ARTIFACT_FOR_PROCESSING_FAILED',
              payload: `Failed to process deal activity data`,
            });
            if (typeof errCb === 'function') {
              errCb();
            }
          }
        } catch (e) {
          dispatch({
            type: 'SUBMITTING_DEAL_ARTIFACT_FOR_PROCESSING_FAILED',
            payload: `Failed to process deal activity data`,
          });
          if (typeof errCb === 'function') {
            errCb();
          }
        }
        unsubscribe();
      });
    } catch (e) {
      console.log(e);
      dispatch({
        type: 'SUBMITTING_DEAL_ARTIFACT_FOR_PROCESSING_FAILED',
        payload: `Failed to process deal activity data`,
      });
      if (typeof errCb === 'function') {
        errCb();
      }
    }
  };
};

export default processDealArtifact;
